module.exports = __webpack_public_path__ + "img/AR.fw.61dc9336.png";